import { mergeWith } from 'ramda';

import { Company } from 'types/payments';

export const getVoucherType = (booking) => {
  const fincomObject = booking.additionalDetails?.filter((additionalDetail) => additionalDetail.key === 'FINCOM');
  const fincomValues = fincomObject?.map((obj) => obj.value);
  const distinctFincomValues = [...new Set(fincomValues)];

  if (distinctFincomValues?.includes(Company.EHL)) {
    return Company.EHL;
  }
  if (distinctFincomValues?.includes(Company.EIL)) {
    return Company.EIL;
  }

  return distinctFincomValues[0];
};

export const buildCustomerData = (allPassengers, customer) =>
  allPassengers.reduce((acc, pax) => mergeWith((pax1, pax2) => pax1 || pax2, acc, pax), customer);
